
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import {windVane} from "../../../utils/tmallGenius"

export default {
components: {Group, Cell, Selector, XInput, Loading, Icon},
data() {
return {
activeDotIdx: 0,
dotArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
wifiName: "",
wifiPassword: "",
wifiList: [],
isLoading: false,
passwordTypeIsText: false, //密码是字符还是密文
isBottomBtnUp: false //底部大按钮是否上浮
}
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("添加设备")
next()
},
/*------------------------------------------- 启动运行 -------------------------------------------------------*/
created() {
this.getWifiList()
},
methods: {
/*------------------------------------------- 自定义方法 -------------------------------------------------------*/
/*  获取上一步保存的wifi列表
* */
getWifiList() {
let wifiListStr = sessionStorage.getItem("wifiList")
if (wifiListStr) {
this.wifiList = JSON.parse(wifiListStr) //上一步的wifi列表
}
let firstWifi = sessionStorage.getItem("firstWifi") //一开始进入首页的连接的wifi
if (firstWifi) {
this.wifiList.unshift(firstWifi)
}
this.wifiList = [...new Set(this.wifiList)] //去重
this.wifiName = this.wifiList[0] || ""
},
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
/*  点击开始连接
* */
startLinkClick() {

if (this.wifiName.trim() === "") {
this.$vux.toast.show({
text: "wifi名字不可为空",
type: "cancel"
})
return
}
if (this.wifiPassword.trim() === "") {
this.$vux.toast.show({
text: "wifi密码不可为空",
type: "cancel"
})
return
}


this.isLoading = true
let isCanTimeout = true

setTimeout(() => {

this.isLoading = false
if (isCanTimeout) {
this.$vux.toast.show({
text: "连接超时",
type: "cancel"
})
}
}, 10000)

windVane
.sendMessage({
message: JSON.stringify({
cmd: 81,
ssid: this.wifiName,
password: this.wifiPassword
})
})
.then(result => {
isCanTimeout = false
this.isLoading = false
let res = result.result.split("}")[0] + "}" //硬件有可能包含乱码字符
res = JSON.parse(res).result
if (res === 0) {
this.toast_success()
setTimeout(() => {
this.$router.replace({
path: "/connect/wifi/bind",
query: {
name: this.$route.query.name,
wifi: this.wifiName
}
})
}, 1000)
}
})
.catch(e => {
this.isLoading = false
isCanTimeout = false
this.$vux.toast.show({
text: "设备连接失败",
type: "cancel"
})
})
},
/*  密码icon点击
* */
passwordIconClick() {
this.passwordTypeIsText = !this.passwordTypeIsText
}
}
}



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/ConnectWifi.vue